import React, { useRef } from "react";
import PropTypes from "prop-types";
import { UncontrolledTooltip } from "reactstrap";
import PointerEvents from "stylesheets/utilities/pointerEvents.module.scss";
import classNames from "classnames";

import MaterialIcon from "./MaterialIcon";

const IconWithTooltip = ({ icon, placement, children, tooltipClassName, ...props }) => {
  const tooltipRef = useRef(null);

  return (
    <React.Fragment>
      <MaterialIcon ref={tooltipRef} name={icon} {...props} />
      <UncontrolledTooltip placement={placement} target={tooltipRef} className={classNames(PointerEvents.none, tooltipClassName)}>
        {children}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};

IconWithTooltip.propTypes = {
  /**
   * See Material Icon documentation for available icons
   */
  icon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  /**
   * See Reactstrap documentation for available placements
   */
  placement: PropTypes.string,
  /**
   * Attach a class directly to the tooltip
   */
  tooltipClassName: PropTypes.string
};

IconWithTooltip.defaultProps = {
  placement: "right",
  tooltipClassName: ""
};

export default IconWithTooltip;
